const requireAll = requireContext => requireContext.keys().map(requireContext);
const req = require.context("./svg", false, /\.svg$/);

requireAll(req)



// WEBPACK FOOTER //
// ./pc/yiqijian-video/assets/icons/index.js